export default __webpack_public_path__ + "static/media/images-3.a5ccc3a2.jpg";